jQuery(document).ready(function () {
    if ($('.testimonial-section .testimonial-list').length > 0) {
        $('.testimonial-section .testimonial-list').addClass('owl-carousel');
        $('.testimonial-section .testimonial-list').on('initialized.owl.carousel changed.owl.carousel', function (e) {
            if (!e.namespace) {
                return;
            }
            var carousel = e.relatedTarget;
            $('.slider-counter').text(carousel.relative(carousel.current()) + 1 + ' / ' + carousel.items().length);
        }).owlCarousel({
            nav: true,
            dots: false,
            items: 1,
            loop: true,
            autoplay: false,
            margin: 0,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                }
            }
        });
    }
    if ($('.product-collection ul.product-grid').length > 0) {
        var owl = $('.product-collection ul.product-grid');
        $('.product-collection ul.product-grid').addClass('owl-carousel');
        $('.product-collection ul.product-grid').owlCarousel({
            nav: true,
            dots: false,
            items: 4,
            loop: false,
            rewind: true,
            autoplay: false,
            margin: 12,
            slideBy: 1,
            responsive: {
                0: {
                    items: 2,
                    margin: 6
                },
                480: {
                    items: 2,
                    margin: 6
                },
                768: {
                    items: 3
                },
                1023: {
                    items: 4,
                    slideBy: 1
                }
            }
        });

        var isScrolling = false;

        owl.on('mousewheel', '.owl-stage', function (e) {
            clearTimeout(triggerSlider);
            var triggerSlider = setTimeout(function () {
                if (isScrolling == false) {
                    isScrolling = true;
                    if (e.deltaX > 0) {
                        owl.trigger("next.owl");
                        setTimeout(function () {
                            isScrolling = false;
                        }, 2500);
                    } else {
                        if (e.deltaX == 0) {
                            var scroll = $(window).scrollTop();
                            var nDown = scroll + 100;
                            var nUp = scroll - 100;
                            if (e.deltaY > 0) {
                                $('html, body').animate({ scrollTop: nUp }, 200);
                            } else {
                                $('html, body').animate({ scrollTop: nDown }, 200);
                            }
                            setTimeout(function () {
                                isScrolling = false;
                            }, 200);
                        } else {
                            owl.trigger("prev.owl");
                            setTimeout(function () {
                                isScrolling = false;
                            }, 2500);
                        }
                    }
                }
            }, 50);

            e.preventDefault();
        });
    }

    if ($('.gift-guide-list.show-mobile').length > 0) {
        $('.gift-guide-list.show-mobile').addClass('owl-carousel');
        $('.gift-guide-list.show-mobile').owlCarousel({
            nav: false,
            dots: false,
            items: 1,
            loop: false,
            autoplay: false,
            margin: 11,
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 2
                }
            }
        });
    }

    if ($('.piercing-styling-slider-wraper .piercing-styling-slider-list').length > 0) {
        $('.piercing-styling-slider-wraper .piercing-styling-slider-list').addClass('owl-carousel');
        $('.piercing-styling-slider-wraper .piercing-styling-slider-list').owlCarousel({
            nav: false,
            dots: true,
            items: 1,
            loop: false,
            autoplay: false,
            margin: 0,
            responsive: {
                0: {
                    items: 1
                },
                1023: {
                    items: 1
                }
            }
        });
    }

    if ($('.piercing-styling-list').length > 0) {
        $('.piercing-styling-list').addClass('owl-carousel');
        $('.piercing-styling-list').owlCarousel({
            nav: false,
            dots: false,
            items: 2,
            loop: false,
            autoplay: false,
            margin: 0,
            responsive: {
                0: {
                    items: 1,
                    margin: 0
                },
                480: {
                    items: 2,
                    margin: 5
                }
            }
        });
    }

    $('.gift-guide-menu-wraper .gift-guide-list .gift-guide-item a').on('click', function (e) {
        var href = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(href).offset().top
        }, '300');
        e.preventDefault();
    });

    $('.icon-expand').click(function () {
        $('body').addClass('overlay');
        $(this).parent().next('.content-info').toggleClass('open');
        // $(this).closest('.piercers-item').siblings().find('.content-info').removeClass('open');
        // $(this).closest('.piercers-item').siblings().find('.icon-expand').removeClass('open');
        // $(this).toggleClass('open');
        // $('.meet-our-priercers .piercers-item').addClass('overlay');
        // if ($(this).hasClass('open') == true) {
        //     $(this).closest('.piercers-item').removeClass('overlay');
        // } else {
        //     if ($('.icon-expand.open').length == 0) {
        //         $('.piercers-item').removeClass('overlay');
        //     } else {
        //         $(this).closest('.piercers-item').addClass('overlay');
        //     }
        // }

    });

    $('.content-info .close-icon').click(function () {
        $('body').removeClass('overlay');
        // $('.icon-expand').removeClass('open');
        $(this).parent('.content-info').removeClass('open');
        // $('.piercers-list .piercers-item').removeClass('overlay');
    });

    $('.home-block-text-wraper .block-content .content-right .read-more span').click(function () {
        $(this).parent().next('.section-content-more').slideDown();
        $(this).hide();
    });

    $('.home-block-text-wraper .block-content .content-right .pack-up span').click(function () {
        $(this).closest('.section-content-more').slideUp();
        $('.home-block-text-wraper .block-content .content-right .read-more span').slideDown()
    });

});